import path from 'path-browserify';

/**
 * 获取 url 文件名
 * @param { string } url
 */
export function extraFileName(url: string, withSuffix = true) {
  // 参数验证
  if (typeof url !== 'string') {
    throw new TypeError('url参数必须是字符串');
  }

  if (!url) return '';

  try {
    let _url = decodeURIComponent(url);
    if (~_url.lastIndexOf('?')) {
      _url = _url.slice(0, _url.lastIndexOf('?'));
    }
    const fileName = path.basename(_url);

    if (!withSuffix) {
      const lastDotIndex = fileName.lastIndexOf('.');
      if (lastDotIndex !== -1) {
        return fileName.slice(0, lastDotIndex);
      }
    }
    return fileName;
  } catch (e) {
    // 处理编码错误
    console.error('解码URL时发生错误:', e);
    return url;
  }
}
